<template>
  <div>
    <!-- Header -->

    <!-- Page content -->
    <b-container class="py-7 py-lg-8 pt-lg-9">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" sm="12">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div>
                <b-tabs pills>
                  <b-tab>
                    <template v-slot:title>
                      <i class="ni ni-bell-55 mr-2"></i> ตรวจสภาพ
                    </template>
                    <b-card>
                      <b-list-group>
                        <b-list-group-item
                          href="javascript:;"
                          class="d-flex justify-content-between align-items-center"
                          >ล้างรถ <span>21/01/23</span></b-list-group-item
                        >
                        <b-list-group-item
                          href="javascript:;"
                          class="d-flex justify-content-between align-items-center"
                          >ล้างรถ <span>21/01/23</span></b-list-group-item
                        >
                      </b-list-group>

                      <div class="text-center">
                        <base-button
                          type="primary"
                          native-type="submit"
                          block
                          v-b-modal.modal-3
                          >เพิ่มการตรวจสภาพ</base-button
                        >
                      </div>
                    </b-card>

                    <b-modal id="modal-3" title="ตรวจสภาพ">
                      <b-form role="form-3" @submit.prevent="onSubmit2">
                        <base-input
                          alternative
                          class="mb-3"
                          name="text"
                          type="text"
                          placeholder="รายการ"
                        >
                        </base-input>

                        <base-input
                          alternative
                          class="mb-3"
                          name="weight"
                          type="text"
                          placeholder="ค่าใช้จ่าย"
                        >
                        </base-input>

                        <base-input
                          alternative
                          class="mb-3"
                          name="weight"
                          type="text"
                          placeholder="รายละเอียด"
                        >
                        </base-input>
                        <b-form-file
                          class="mb-3"
                          @change="filesChange"
                          placeholder=" อัพโหลดรูป"
                          drop-placeholder="Drop file here..."
                        ></b-form-file>
                      </b-form>
                    </b-modal>
                  </b-tab>
                  <b-tab active>
                    <template v-slot:title>
                      <i class="ni ni-cloud-upload-96 mr-2"></i> เช็คระยะ
                    </template>
                    <b-card>
                      <b-list-group>
                        <b-list-group-item
                          href="javascript:;"
                          class="d-flex justify-content-between align-items-center"
                          >เลขกิโลเมตร : 11,234
                          <span>21/01/23</span></b-list-group-item
                        >
                        <b-list-group-item
                          href="javascript:;"
                          class="d-flex justify-content-between align-items-center"
                          >เลขกิโลเมตร : 21,234
                          <span>21/01/23</span></b-list-group-item
                        >
                      </b-list-group>

                      <div class="text-center">
                        <base-button
                          type="primary"
                          native-type="submit"
                          block
                          v-b-modal.modal-1
                          >เพิ่มการเช็คะระยะ</base-button
                        >
                      </div>
                    </b-card>

                    <b-modal id="modal-1" title="เช็คระยะ">
                      <b-form role="form-2" @submit.prevent="onSubmit">
                        <base-input
                          alternative
                          class="mb-3"
                          name="text"
                          type="text"
                          placeholder="ประเภทการเช็คระยะ"
                        >
                        </base-input>

                        <base-input
                          alternative
                          class="mb-3"
                          name="weight"
                          type="text"
                          placeholder="เลขกิโลเมตร"
                        >
                        </base-input>

                        <base-input
                          alternative
                          class="mb-3"
                          name="weight"
                          type="text"
                          placeholder="รายการซ่อม"
                        >
                        </base-input>
                        <b-form-file
                          class="mb-3"
                          @change="filesChange"
                          placeholder="รูปใบเสร็จ อัพโหลดรูป"
                          drop-placeholder="Drop file here..."
                        ></b-form-file>
                        <base-input
                          alternative
                          class="mb-3"
                          name="weight"
                          type="text"
                          placeholder="ยอดค่าใช้จ่าย"
                        >
                        </base-input>
                      </b-form>
                    </b-modal>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      <i class="ni ni-calendar-grid-58 mr-2"></i> เปลี่ยนยาง
                    </template>
                    <b-card>
                      <b-list-group>
                        <b-list-group-item
                          href="javascript:;"
                          class="d-flex justify-content-between align-items-center"
                          >ครั้งที่ 1 <span>21/01/23</span></b-list-group-item
                        >
                        <b-list-group-item
                          href="javascript:;"
                          class="d-flex justify-content-between align-items-center"
                          >ครั้งที่ 2 <span>21/01/23</span></b-list-group-item
                        >
                      </b-list-group>

                      <div class="text-center">
                        <base-button
                          type="primary"
                          native-type="submit"
                          block
                          v-b-modal.modal-4
                          >เพิ่มการเปลี่ยนยาง</base-button
                        >
                      </div>
                    </b-card>

                    <b-modal id="modal-4" title="เปลี่ยนยาง">
                      <b-form role="form-4" @submit.prevent="onSubmit2">
                        <base-input
                          alternative
                          class="mb-3"
                          name="text"
                          type="text"
                          placeholder="ครั้งที่ "
                        >
                        </base-input>

                        <base-input
                          alternative
                          class="mb-3"
                          name="weight"
                          type="text"
                          placeholder="ค่าใช้จ่าย"
                        >
                        </base-input>

                        <base-input
                          alternative
                          class="mb-3"
                          name="weight"
                          type="text"
                          placeholder="รายละเอียด"
                        >
                        </base-input>
                        <b-form-file
                          class="mb-3"
                          @change="filesChange"
                          placeholder=" อัพโหลดรูป"
                          drop-placeholder="Drop file here..."
                        ></b-form-file>
                      </b-form>
                    </b-modal>
                  </b-tab>
                </b-tabs>
              </div> </b-card-body
          ></b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    onSubmit() {
      // this will be called only after form is valid. You can do api call here to login
    },
  },
};
</script>
